




















import Vue from 'vue';
import { RouteName, Role } from '@/utils/enums';

export default Vue.extend({
  name: 'navigation-component',
  computed: {
    navLayout() {
      return this.$route.meta.nav;
    },
    menuItemsVisible() {
      return this.$route.name !== RouteName.HOME;
    },
    userIsZorgProfessional() {
      return this.$store.getters.getUserGroups.includes(Role.ZORG_PROFESSIONAL);
    }
  },
  methods: {
    logout() {
      // This will redirect to the logout page of the provider.
      this.$store.dispatch('LOGOUT');
    }
  }
});
